/* Structure storefront copy without rewriting the merchant's text or links. */
(() => {
  if (window.MouniReadableDrawers) return;
  window.MouniReadableDrawers = true;
  const signatures = new WeakMap();
  const blocked = 'form,input,button,textarea,select,script,style,table,img,video,iframe,svg,model-viewer';
  const blockChildren = 'p,div,ul,ol,li,h1,h2,h3,h4,h5,h6,blockquote';
  function splitCopy(node) {
    if (node.querySelector(blockChildren + ',' + blocked) || node.closest('li,table,form,.tab-popup-header,.tab-showMore')) return;
    const text = node.textContent;
    const breaks = [...node.querySelectorAll('br')];
    const ranges = [];
    if (breaks.length >= 2) {
      let start = null;
      for (const end of [...breaks, null]) {
        const range = document.createRange();
        if (start) range.setStartAfter(start); else range.setStart(node, 0);
        if (end) range.setEndBefore(end); else range.setEnd(node, node.childNodes.length);
        if (range.toString().trim()) ranges.push(range);
        start = end;
      }
    } else if (text.length > 320 && !breaks.length) {
      const cuts = [0];
      for (const match of text.matchAll(/[.!؟!?؛](?=\s+[^\d]|\s*$)/g)) {
        const end = match.index + 1;
        if (end - cuts[cuts.length - 1] >= 160 && text.length - end >= 60) cuts.push(end);
      }
      if (cuts.length === 1) return;
      cuts.push(text.length);
      const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT), parts = [];
      let offset = 0;
      while (walker.nextNode()) {const part=walker.currentNode;parts.push({node:part,start:offset,end:offset+part.length});offset+=part.length;}
      const locate = position => {const part=parts.find(p=>position<=p.end);return [part.node,position-part.start];};
      for (let i=1;i<cuts.length;i++) {const range=document.createRange();range.setStart(...locate(cuts[i-1]));range.setEnd(...locate(cuts[i]));ranges.push(range);}
    }
    if (ranges.length < 2) return;
    const output = document.createDocumentFragment();
    ranges.forEach(range => {const p=document.createElement('p');p.className='mouni-readable__paragraph';p.dir='auto';p.append(range.cloneContents());output.append(p);});
    const links = root => JSON.stringify([...root.querySelectorAll('a')].map(a=>[a.getAttribute('href'),a.textContent]));
    // Fall back to the untouched original if rich content cannot be preserved.
    if (output.textContent.replace(/\s/g,'') !== text.replace(/\s/g,'') || links(output)!==links(node)) return;
    if (node.matches('.mouni-product-drawer__body,.toggle-content,.tab-popup-content')) node.replaceChildren(output);
    else node.replaceWith(output);
  }
  function bulletCopy(body) {
    if(body.querySelector('form,input,button,textarea,select,script,style,.tab-popup-header,.tab-showMore')) return;
    const list=document.createElement('ul'); list.className='mouni-readable__bullets';
    let pending=document.createDocumentFragment();
    const flush=()=>{
      if(pending.textContent.trim() || pending.querySelector('img[src],img[srcset],video,audio,iframe,table,svg,model-viewer')) {
        const item=document.createElement('li');
        if(!pending.textContent.trim()) item.className='mouni-readable__media';
        item.append(pending); list.append(item);
      }
      pending=document.createDocumentFragment();
    };
    const visit=node=>{
      if(node.nodeType===1 && node.tagName==='BR') {flush();return;}
      if(node.nodeType===1 && /^(P|DIV|UL|OL|LI|H[1-6]|BLOCKQUOTE)$/.test(node.tagName)) {
        flush(); [...node.childNodes].forEach(visit); flush();
      } else {pending.append(node.cloneNode(true));}
    };
    [...body.childNodes].forEach(visit); flush();
    const assets=root=>JSON.stringify([...root.querySelectorAll('a,img,video,audio,iframe,source,svg,table')].filter(e=>e.getAttribute('src')||e.getAttribute('srcset')||e.getAttribute('href')||e.matches('svg,table')).map(e=>[e.tagName,e.getAttribute('src'),e.getAttribute('srcset'),e.getAttribute('href'),e.textContent]));
    // Lists change presentation only; keep the source when any rich content differs.
    if(list.textContent.replace(/\s/g,'')!==body.textContent.replace(/\s/g,'') || assets(list)!==assets(body)) return;
    if(list.children.length) body.replaceChildren(list);
  }
  function format() {
    // Native exclusive accordion grouping also applies to newly rendered drawers.
    document.querySelectorAll('.template-product .mouni-product-drawer').forEach(drawer=>drawer.setAttribute('name','mouni-product-details'));
    document.querySelectorAll('.template-product .mouni-product-drawer__body,.template-product .tabs-contents .toggle-content').forEach(body => {
      const signature=body.innerHTML;
      if (signatures.get(body)===signature) return;
      body.classList.add('mouni-readable');
      const candidates=[body,...body.querySelectorAll('p,div')];
      candidates.forEach(node=>{if(body.contains(node)||body===node)splitCopy(node);});
      bulletCopy(body);
      signatures.set(body,body.innerHTML);
    });
  }
  function start() {
    format();
    const root=document.querySelector('#MainContent');
    if (!root) return;
    let frame;
    new MutationObserver(()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(format);}).observe(root,{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  // Retain exclusive behavior in browsers that do not support details[name].
  document.addEventListener('toggle',event=>{
    const drawer=event.target;
    if(!drawer.matches?.('.template-product .mouni-product-drawer')||!drawer.open)return;
    document.querySelectorAll('.template-product .mouni-product-drawer[open]').forEach(other=>{if(other!==drawer)other.open=false;});
  },true);
  document.addEventListener('shopify:section:load',format);
})();
